import DashboardLayout from '../layout/DashboardLayout.vue'
// GeneralViews
import NotFound from '../pages/NotFoundPage.vue'
// Admin pages
import DevicesPage from "../pages/devices/DevicesPage";
import OverviewPage from "../pages/OverviewPage";
import LoginPage from "../pages/auth/LoginPage";
import AuthLayout from "../layout/AuthLayout";
import RegisterPage from "../pages/auth/RegisterPage";
import ResetPage from "../pages/auth/ResetPage";
import DeviceDetailsPage from "../pages/devices/DeviceDetailsPage";
import DeviceDataPage from "../pages/devices/DeviceDataPage";
import DeviceChartsPage from "../pages/devices/DeviceChartsPage";
import LocalizationsPage from "../pages/localizations/LocalizationsPage";
import UsersPage from "../pages/users/UsersPage";
import DeviceDataPowerPage from "../pages/devices/DeviceDataPowerPage";
import DeviceAlertsPage from "../pages/devices/DeviceAlertsPage";


const routes = [
  {
    path: '/',
    component: DashboardLayout,
    redirect: '/devices/list',
  },
  // {
  //   path: '/panel',
  //   redirect: '/panel/overview',
  //   component: DashboardLayout,
  //   children: [
  //     {
  //       path: 'overview',
  //       name: 'Overview',
  //       component: OverviewPage
  //     },
  //   ]
  // },
  {
    path: '/devices',
    redirect: '/devices/list',
    component: DashboardLayout,
    children: [
      {
        path: 'list',
        name: 'Devices',
        component: DevicesPage
      },
      {
        path: 'details/:deviceId',
        name: 'DeviceDetails',
        component: DeviceDetailsPage
      },
      {
        path: 'data/:deviceId',
        name: 'DeviceData',
        component: DeviceDataPage
      },
      {
        path: 'data/power/:deviceId',
        name: 'DeviceDataPower',
        component: DeviceDataPowerPage
      },
      {
        path: 'data/:deviceId/:localizationHistoryId',
        name: 'DeviceData',
        component: DeviceDataPage
      },
      {
        path: 'charts/:deviceId',
        name: 'DeviceCharts',
        component: DeviceChartsPage
      },
      {
        path: 'charts/:deviceId/:localizationHistoryId',
        name: 'DeviceCharts',
        component: DeviceChartsPage
      },
      {
        path: 'alerts/:deviceId',
        name: 'DeviceAlerts',
        component: DeviceAlertsPage
      }
    ]
  },
  {
    path: '/localizations',
    redirect: '/localizations/list',
    component: DashboardLayout,
    children: [
      {
        path: 'list',
        name: 'Localizations',
        component: LocalizationsPage
      }
    ]
  },
  {
    path: '/users',
    redirect: '/users/list',
    component: DashboardLayout,
    children: [
      {
        path: 'list',
        name: 'users',
        component: UsersPage
      }
    ]
  },
  {
    path: '/auth',
    redirect: '/auth/login',
    component: AuthLayout,
    children: [
      {
        path: 'login',
        name: 'Login',
        component: LoginPage
      },
      {
        path: 'register',
        name: 'Register',
        component: RegisterPage
      },
      {
        path: 'reset',
        name: 'Reset',
        component: ResetPage
      }
    ]
  },
  {path: '*', component: NotFound}
];

export default routes
